import { Page } from 'components/shared';
import { SetDataStoreForm } from './set-data-store-form';

export const DataStoreCachePage = () => {
  return (
    <Page
      title="Set Data Store Cache"
      subtitle="Configure the location cache settings. Use only for test locations"
    >
      <SetDataStoreForm />
    </Page>
  );
};
